import { Dispatch, SetStateAction } from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { GRAPH_TYPE, GRAPH_TYPE_DAILY } from "../../utils/enums";

type props = {
  customerType: string;
  setCustomerType: Dispatch<SetStateAction<string>>;
  data: any;
  setGraphFor: Dispatch<SetStateAction<number | null | undefined>>;
};

const MaintenanceGraph = ({
  data,
  customerType,
  setCustomerType,
  setGraphFor,
}: props) => {
  return (
    <div className="cards table_card">
      <div className="cards_header">
        <div className="left_s">
          <h2>Customers</h2>
        </div>
        <div className="right_s">
          <p>
            <span
              style={{
                color: customerType === GRAPH_TYPE_DAILY.DAILY ? "#c24b09" : "",
              }}
              onClick={() => {
                setGraphFor(GRAPH_TYPE.USER_GRAPH);
                setCustomerType(GRAPH_TYPE_DAILY.DAILY);
              }}
            >
              A day
            </span>
            <span
              style={{
                color:
                  customerType === GRAPH_TYPE_DAILY.WEEKLY ? "#c24b09" : "",
              }}
              onClick={() => {
                setGraphFor(GRAPH_TYPE.USER_GRAPH);
                setCustomerType(GRAPH_TYPE_DAILY.WEEKLY);
              }}
            >
              A week
            </span>
            <span
              style={{
                color:
                  customerType === GRAPH_TYPE_DAILY.MONTHLY ? "#c24b09" : "",
              }}
              onClick={() => {
                setGraphFor(GRAPH_TYPE.USER_GRAPH);
                setCustomerType(GRAPH_TYPE_DAILY.MONTHLY);
              }}
            >
              A month
            </span>
            <span
              style={{
                color:
                  customerType === GRAPH_TYPE_DAILY.YEARLY ? "#c24b09" : "",
              }}
              onClick={() => {
                setGraphFor(GRAPH_TYPE.USER_GRAPH);
                setCustomerType(GRAPH_TYPE_DAILY.YEARLY);
              }}
            >
              A year
            </span>
          </p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          data={data?.userData || []}
          margin={{
            top: 20,
            right: 5,
            left: 5,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="count" fill="#C14A09" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MaintenanceGraph;
